export const SCREEN_WIDTH_BREAKPOINT: string = "1000px";
